<template>
  <div>
    <el-button type="primary" size="small" @click="openSee">
      <slot></slot>
    </el-button>

    <el-dialog
        title="新加"
        :visible.sync="openStatus"
        width="60%"
        :fullscreen="false"
        :modal-append-to-body="true"
        :append-to-body="true"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :destroy-on-close="true"
        :before-close="closeSee"
    >
      <div style="padding: 20px;">
        <el-form label-width="120px">
          <el-form-item label="名称">
            <el-input v-model="form.name" placeholder="请输入名称"></el-input>
          </el-form-item>
          <el-form-item label="手机号码">
            <el-input v-model="form.mobile" placeholder="请输入登录手机号码"></el-input>
          </el-form-item>
          <el-form-item label="登录密码">
            <el-input v-model="form.password" placeholder="请输入登录密码"></el-input>
          </el-form-item>
          <el-form-item label="再次登录密码">
            <el-input v-model="form.password_again" placeholder="请再次登录密码"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="toSubmit">提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  components: {},
  data() {
    return {
      list: [],
      openStatus: false,
      form: {
        name: '',
        mobile: '',
        password: '',
        password_again: '',
      }
    };
  },
  computed: mapState({
    config: (state) => state.config,
  }),
  props: {},
  mounted() {},
  methods: {
    // 筛选
    openSee() {
      const _this = this;
      _this.form = {
        name: '',
        mobile: '',
        password: '',
        password_again: '',
      }
      _this.openStatus = true;
    },
    closeSee() {
      const _this = this;
      _this.form = {
        name: '',
        mobile: '',
        password: '',
        password_again: '',
      }
      _this.openStatus = false;
    },
    toSubmit() {
      const _this = this;
      _this.submitIng = false;
      _this.$api.peopleCreate(_this.form)
          .then(res => {
            _this.submitIng = false;
            _this.closeSee();
            _this.$emit('finish', res);
            _this.$message.success('添加成功');
          })
          .catch(err => {
            _this.submitIng = false;
            _this.$message.error(err.msg);
          })
    }
  },
};
</script>